import Component from './Component';
import 'js-marker-clusterer';
import googleMaps from '../lib/injectGoogleMaps';
import { styles as mapStyles } from '../lib/googleMaps';
import { styles as mapStylesSa } from '../lib/googleMaps-sa';
import overlappingMarkerSpiderfier from '../lib/overlappingMarkerSpiderfier';
import queryString from 'query-string'; // LEGACY: browsers now have a native Search Parameters API that can do this.
// var Handlebars = require('handlebars');
import Handlebars from 'handlebars';

let activeMapStyles = mapStyles; // Default map styles
/// sitecode defined in inline script in the HTML
/* global siteCode */
const validSiteCodes = ['sa', 'corp', 'trade', 'int'];
if (validSiteCodes.includes(siteCode)) {
  console.log(`Using map styles for siteCode: ${siteCode}`);
  activeMapStyles = mapStylesSa; // Use SA map styles if siteCode is valid
}

export default class SearchMap extends Component {
  constructor() {
    super();
    // console.log('SearchMap component.');
    this.mainMapLoaded = false;
    this.googleLoaded = false;
    this.overlappingMarkerSpiderfierLoaded = false;
    this.isMobile = window.innerWidth < 768;
    this.defaultMarker = "/static/images/m_map-marker-alt.svg";
    this.svgMarker = {
      path: "M172.268 501.67C26.97 291.031 0 269.413 0 192 0 85.961 85.961 0 192 0s192 85.961 192 192c0 77.413-26.97 99.031-172.268 309.67-9.535 13.774-29.93 13.773-39.464 0zM192 272c44.183 0 80-35.817 80-80s-35.817-80-80-80-80 35.817-80 80 35.817 80 80 80z",
      fillColor: "crimson",
      fillOpacity: 1,
      strokeColor: "crimson",
      strokeWeight: 1,
      strokeOpacity: 0.5,
      rotation: 0,
      scale: 0.07,
      // add anchor later // anchor: new google.maps.Point(15, 30),
    };
    this.mapResults = [];
  }

  load() {
    this.bindEvents();
    super.load();
  }

  bindEvents() {
    // get brandColor and siteCode from body if possible
    this.setBrandAttributes();

    if (document.querySelectorAll('.map-container').length > 1) {
      console.warn('Multiple map containers found. Map infoWindows might show innacuracies.');
    };

    // console.log('this: ', this);
    $(window).on('map-visible', this.initMaps.bind(this));  // main Search Results Map

    this.processRelatedContentMaps();  // Related Content Maps
    //https://localhost:44320/umbraco/api/searchapi/get?sort=sort_relevance_s-asc&cat=ACCOMM&p=1&pageSize=20&reg=59000105&catCms=true&subCatCms=false&regionCms=true&hideServ=true&onlyDeals=False&onlyJobs=False&hideSoldOut=true&currentUrl=https%3A%2F%2Flocalhost%3A44320%2Fsearch%3FSearch%3D%26q%3D&excludeProductServiceItems=True
    // Allow the main search map to be loaded via URL
    const queryStringParams = queryString.parse(location.search + "&sort=sort_relevance_s-asc&cat=ACCOMM&p=1&pageSize=20&reg=59000105&catCms=true&subCatCms=false&regionCms=true&hideServ=true&onlyDeals=False&onlyJobs=False&hideSoldOut=true&currentUrl=https%3A%2F%2Flocalhost%3A44320%2Fsearch%3FSearch%3D%26q%3D&excludeProductServiceItems=True");
    // console.log("location.search: ", location.search);
    if (queryStringParams.MapSearch && queryStringParams.MapSearch == "true") {
      this.initMainSearchResultsMap();
      $("#map-layout").show();
    }
    if (queryStringParams.HideGrid && queryStringParams.HideGrid == "true") {
      $("#grid-layout").hide();
    }
  }

  initMaps() {
    this.initMainSearchResultsMap();
  }

  initMainSearchResultsMap() {   // the map on search results page
    if (this.mainMapLoaded) {
      return;
    }

    var self = this;
    if (this.overlappingMarkerSpiderfierLoaded) {
      self.loadMapMarkers('map', self.initAMap, self);
      return;
    }

    googleMaps(() => {
      this.googleLoaded = true;
      overlappingMarkerSpiderfier(() => {
        this.loadSearchMap();
        this.mainMapLoaded = true;
        this.overlappingMarkerSpiderfierLoaded = true;
      });
    });
  }

  loadSearchMap() {
    this.loadMapMarkers('map', this.initAMap, this);
  }

  setBrandAttributes() {
    // get brandColor and siteCode from body if possible
    const bodyClasses = [...document.querySelector('body').classList]; // convert DOMtokens to array
    const siteCode = bodyClasses.find(item => item.includes("sitecode"));
    this.siteCode = siteCode ? siteCode.split('-')[1] : '';
    const brandColor = bodyClasses.find(item => item.includes("brandcolor"));
    this.brandColor = brandColor ? brandColor.split('-')[1] : '';
  }

  processRelatedContentMaps() {
    if ($('.results-map').length == 0) {
      return;
    }

    var self = this;

    if (self.googleLoaded && self.overlappingMarkerSpiderfierLoaded) {
      self.beginLoadOfRelatedContentMaps(self);
      return;
    }

    googleMaps(() => {
      self.googleLoaded = true;
      overlappingMarkerSpiderfier(() => {
        self.overlappingMarkerSpiderfierLoaded = true;
        self.beginLoadOfRelatedContentMaps(self);
      });
    });
  }

  beginLoadOfRelatedContentMaps(self) {
    // console.log('gather maps and data together.');
    $('.results-map').each(function () {
      var $this = $(this);
      var mapId = $this.attr("id");
      var dataKlmFileUrl = $this.attr("data-klm-file-url");
      var dataJsonScriptId = $this.attr("data-json-script-id");

      self.dataKlmFileUrl = dataKlmFileUrl;
      self.dataJsonScriptId = dataJsonScriptId;
      self.loadMapMarkers(mapId, self.initAMap, self);
    });
    // console.log('self:', self);
  }

  loadMapMarkers(mapId, callback, originalObject) {
    function convertObjectKeysToLowercase(arr) {
      // console.log('cleaning data');
      return arr.map(obj => {
        return Object.fromEntries(Object.entries(obj).map(([key, val]) => [lowerFirstChar(key), val]));
      })
    }

    function lowerFirstChar(string) {
      return string && string[0].toLowerCase() + string.slice(1) || string;
    }

    var ajaxCallback = function (data) {
      if (!data) return;

      // console.log('typeof data:', typeof data);
      // console.log('data:', data);
      // console.log('typeof Array.prototype.slice.call(data):', typeof Array.prototype.slice.call(data));
      // console.log('Array.prototype.slice.call(data):', Array.prototype.slice.call(data));

      // Get all the data before we load the map
      const dataArray = Array.prototype.slice.call(data); // convert data to array. Left in as a precaution, maybe unnecessary.
      const dataClean = convertObjectKeysToLowercase(dataArray);
      // console.log('dataClean:', dataClean);
      // console.log('typeof dataClean:', typeof dataClean);
      let markerData = (dataClean).map((element) => {
        // console.log('element: ', element);
        // if(!element?.Coordinates) return null;
        var coord = element.coordinates;
        if (!coord) return null;

        // Check if the latLng is valid
        const latFloat = parseFloat(coord.lat);
        const longFloat = parseFloat(coord.lng);
        const latInRange = latFloat <= -25.8 && latFloat >= -38.0;
        const longInRange = longFloat >= 129.0 && longFloat <= 141.0;
        // console.log('latFloat longFloat: ', latFloat, longFloat );
        // console.log('latInRange longInRange: ', latInRange, longInRange );

        if (latInRange && longInRange) {
          // Store lat and lon as google position functions
          const latLng = new google.maps.LatLng(coord.lat, coord.lng);
          const marker = {
            position: latLng,
          };
          // title: 'element.title'
          return { marker, id: element.id };
        }

        return null;
      }).filter(x => x !== null);

      // console.log('markerData', markerData);
      callback(mapId, markerData, originalObject);
    };

    if (originalObject.dataJsonScriptId) {
      //seeing we've got the data on the page, we may aswell read it from the json rather than doing an ajax call ;)
      const jsonData = $('#' + originalObject.dataJsonScriptId).html();
      if (jsonData) {
        var mapResults = JSON.parse(jsonData);
        // console.log('mapResults:', mapResults);
        let mapResultsClean = convertObjectKeysToLowercase(mapResults); // Umbraco 11 capitalized variable names.
        originalObject.mapResults = mapResultsClean;
        this.googleLoaded = true;
        ajaxCallback(mapResultsClean);
      } else {
        callback(mapId, [], originalObject);
      }
    } else {
      $(".loading-img-overlay").show();

      //Remove pageing data (e.g. &page=1&pagesize=12)
      let formData = $('#frmSearchFilter').serialize();

      const startStrip = formData.indexOf('&page=');
      formData = startStrip > 0 ? formData.substring(0, startStrip) : formData;

      // Remove duplicates
      formData = this.removeDuplicates(formData);

      $.ajax({
        type: 'POST',
        url: "/api/search/map",
        data: formData,
        cache: false,
        crossDomain: false,
        success: function (data) {
          let mapResultsClean = convertObjectKeysToLowercase(data.items); // Umbraco 11 capitalized variable names.
          originalObject.mapResults = mapResultsClean;

          ajaxCallback(mapResultsClean);
          $(".loading-img-overlay").hide();
        },
        error: function () {
          //console.log("could not load main map")
          alert("Sorry we hit an issue displaying the map search results");
          $(".loading-img-overlay").show();
        }
      });
    }
  }

  removeDuplicates(formData) {
    var formDataArray = formData.split('&');
    var formDataFiltered = [];
    var formDataFilteredKeys = [];
    formDataArray.forEach(function (item) {

      const data = item.split('=')[1];
      var key = item.split('=')[0].toLowerCase();
      if (key == 'q') {
        key = 'searchQuery';
        item = `searchQuery=${data}`;
      }
      if (key == 'location') {
        key = 'region';
        item = `region=${data}`;
      }
      if (formDataFilteredKeys.indexOf(key) == -1 && data != '') {
        formDataFilteredKeys.push(key);
        formDataFiltered.push(item);
      }
    });

    return formDataFiltered.join('&');
  }

  initAMap(mapId, markerData, originalObject) {
    let jsMapId = mapId.replace('results-map-', '');
    let listItems = document.querySelectorAll(`.js-mapid-${jsMapId} .js-searchmappan`);
    listItems.forEach(item => {

      // console.log('item: ', item);
      // listen for map list item card click to scroll marker into view
      item.addEventListener("click", function () {
        const productId = this.attributes.productId.value;
        // console.log(originalObject.mapResults);
        const foundObj = markerData.find(x => x.marker.atdwId === productId)

        if (foundObj) {
          // center on marker of clicked card
          map.setCenter(foundObj.marker.position);
          // map.setCenter(foundObj.Coordinates);
          // console.log('centered on item');
        }
      });
    });

    const mapElement = document.getElementById(mapId);

    // Init Google Maps
    const map = new google.maps.Map(mapElement, { styles: activeMapStyles, zoomControl: !originalObject.isMobile });
    // window.testmap = map; // for debugging purposes

    const spiderSupport = originalObject.initSpidifier(map);
    map.spiderSupport = spiderSupport;

    originalObject.injectMarkerData(markerData, map, originalObject);

    google.maps.event.addListener(map, 'idle', () => $(mapElement).removeClass('invisible'));

    originalObject.doEvents('map-loaded');
  }

  // Inject the markers and info windows into the newly created map
  injectMarkerData(markerData, map, originalObject) {
    const bounds = new google.maps.LatLngBounds();
    // console.log('markerData__', markerData);
    // console.log('originalObject__', originalObject);

    const markers = originalObject.createMarkers(markerData, map, originalObject, map.spiderSupport, bounds);
    // Close other infoWindows when an infoWindow is opened
    markers.map((marker) => {
      if (marker) {
        google.maps.event.addListener(marker.marker, 'click', () => {
          if (!marker?.marker) return null;

          // console.log('marker click: ', marker);

          // On click a marker hi-light & scroll to map-list item
          const markerInner = marker.marker;
          const element = document.querySelector('.prod-' + markerInner.atdwId);
          const windowY = window.scrollY;
          const windowX = window.scrollX;
          element ? element.scrollIntoView() : null; // only scroll if item in map-list exists.
          window.scroll(windowX, windowY); // fix window scroll
          markers.filter((m) => m !== marker).map((m) => m.infoWindow.close());
        });
      }
    });

    // Close all other infoWindows when the map is clicked
    google.maps.event.addListener(map, 'click', function () {
      markers.map(function (marker) {
        marker.infoWindow.close()
      })
    });

    if (originalObject.dataKlmFileUrl) {
      var preserveViewport = false;

      if (originalObject.dataKlmFileUrl.indexOf('localhost') > 0) {
        console.log('%cLoading a KML file onto the map requires the URL to be publicly accessible... falling back to sample KML file', 'color: red;');
        originalObject.dataKlmFileUrl = "https://test.tourdownunder.com.au/media/gz1dwqgf/stage-1-tanunda-to-tanunda-final.kml";
        // originalObject.dataKlmFileUrl = "https://um-events-test.azurewebsites.net/media/5esl3znm/adelaide_cbd_riverbank_prologue.kml";
        preserveViewport = false;
      }

      new google.maps.KmlLayer({
        url: originalObject.dataKlmFileUrl,
        preserveViewport: preserveViewport,
        map: map,
      });
    }

    // Center the map on the new markers
    map.setCenter(bounds.getCenter());
    map.fitBounds(bounds);

    this.setBrandAttributes();
    const clusterStyles = [1, 2, 3, 4, 5].map((i) => ({
      url: `/static/images/clusters/${this.siteCode}1.png?v=2`, // spidifier marker icon
      height: 46,
      width: 46,
      textColor: '#fff',
      textSize: 18,
    }));

    var clusterMarkers = markers.map((marker) => marker.marker);
    var markerCluster = new MarkerClusterer(map, clusterMarkers, { styles: clusterStyles });

    const maxClusterZoom = 18;
    markerCluster.setMaxZoom(maxClusterZoom);
  }

  debounce(func, wait, immediate) {
    var timeout;
    return function () {
      var context = this, args = arguments;
      var later = function () {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  }

  getLocalATDWData(map, callback) {
    var urlbase = './api/sitecore/ProductDataApi/GetProductData';
    var mapbounds = map.getBounds();
    var NECorner = mapbounds.getNorthEast();
    var SWCorner = mapbounds.getSouthWest();
    var NWCorner = new google.maps.LatLng(NECorner.lat(), SWCorner.lng());
    var SECorner = new google.maps.LatLng(SWCorner.lat(), NECorner.lng());
    var polygon = [NECorner, SECorner, SWCorner, NWCorner, NECorner].map(function (latlng) {
      return latlng.lng() + " " + latlng.lat();
    }).join(', ');
    var url = urlbase + '?' + 'POLYGON((' + polygon + '))'

    $.get(url, {}, callback);
  }

  createMarkers(markerData, map, originalObject, spiderSupport, bounds) {
    if (!markerData) {
      return [];
    }

    this.setBrandAttributes();

    // add anchor to origianl svgMarker   // (15, 30)
    originalObject.svgMarker.anchor = new google.maps.Point(200, 400);
    // set custom pins color per site
    originalObject.svgMarker.fillColor = this.brandColor;
    originalObject.svgMarker.strokeColor = this.brandColor;


    const markers = markerData.map((data, idx) => {
      if (!data?.marker) return null;

      const currentObj = originalObject.mapResults.find(result => result.id === data.id);
      const marker = new google.maps.Marker(Object.assign(data.marker, {
        map,
        icon: originalObject.svgMarker,
        position: data.marker.position,
        optimized: true,
        id: data.id,
        title: currentObj.title,
        atdwId: currentObj.attributeAtdwId,
        sitecorePinUrl: data.mapPinImage,
        defaultUrl: !data.mapPinImage || data.mapPinImage == "" ? originalObject.defaultMarker : data.mapPinImage
      }));

      // store itemData on the marker for infoWindow lookup later
      marker.mapItemData = currentObj;

      var infoWindow = new google.maps.InfoWindow();

      bounds.extend(data.marker.position);

      // marker.addEventListener('spider_click', function (e) {
      google.maps.event.addListener(marker, 'spider_click', function (e) {  // 'spider_click', not plain 'click'
        originalObject.lookupSinglePin(marker, infoWindow);
      });
      spiderSupport.addMarker(marker);  // adds the marker to the spiderfier _and_ the map

      // Add a class to the infoWindow parent on load
      google.maps.event.addListener(infoWindow, 'domready', () => {
        //$('.gm-style-iw').parent().addClass('info-window');
        // console.log('domready occurs after map actions.');
      });

      return { infoWindow, marker };
    }).filter(m => m !== null);

    return markers;
  }

  /// https://github.com/jawj/OverlappingMarkerSpiderfier
  initSpidifier(map) {
    var self = this;

    var oms = new OverlappingMarkerSpiderfier(map, {
      markersWontMove: true,
      markersWontHide: true,
      basicFormatEvents: true,
      circleSpiralSwitchover: 500, // We only want cirlces, not spirals
      legWeight: 0.5,
      circleFootSeparation: 50,
      circleStartAngle: Math.PI / 12,
      keepSpiderfied: false
    });

    oms.addListener('format', function (marker, status) {
      // var iconURL = status == OverlappingMarkerSpiderfier.markerStatus.SPIDERFIED ? marker.defaultUrl :
      //   status == OverlappingMarkerSpiderfier.markerStatus.SPIDERFIABLE ? marker.defaultUrl :
      //     status == OverlappingMarkerSpiderfier.markerStatus.UNSPIDERFIABLE ? marker.defaultUrl :
      //       marker.defaultUrl;

      marker.icon = self.svgMarker;
    });

    return oms;
  }

  lookupSinglePin(pin, infoWindow) {
    const thisMarker = pin;

    const firstMapTemplate = $("script[data-firstmatch='productMapPopupTemplate']").first();
    const template = Handlebars.compile(firstMapTemplate.html());

    // console.log('firstMapTemplate:', firstMapTemplate);
    // console.log('firstMapTemplate.html():', firstMapTemplate.html());
    // console.log('this.mapResults:', this.mapResults);

    // use the mapItemData stored on the marker
    const item = thisMarker.mapItemData;

    const result = template(item);

    infoWindow.setContent(result);
    infoWindow.open(thisMarker.map, thisMarker);
  }

}
